import React, { useState } from 'react';
import RatioMetricSortBy from './index';
import { SortMode, SortType } from '@home/enums/common';

import type { IRatioMetricSortState } from './index';

const BasicDemo: React.FC = () => {
  const [sorts, setSorts] = useState<IRatioMetricSortState[]>([]);

  return (
    <RatioMetricSortBy
      dataSource="sensortower"
      metric="revenue"
      sorts={sorts}
      onSortsChange={setSorts}
    />
  );
};

const RatioSortDemo: React.FC = () => {
  const [sorts, setSorts] = useState<IRatioMetricSortState[]>([
    {
      dataSource: 'sensortower',
      metric: 'revenue',
      type: SortType.Desc,
      mode: SortMode.Ratio,
    },
  ]);

  return (
    <RatioMetricSortBy
      dataSource="sensortower"
      metric="revenue"
      useRatioSort
      sorts={sorts}
      onSortsChange={setSorts}
    />
  );
};

const WithTipsDemo: React.FC = () => {
  const [sorts, setSorts] = useState<IRatioMetricSortState[]>([]);

  return (
    <RatioMetricSortBy
      dataSource="appannie"
      metric="downloads"
      metricTips="该指标表示应用在指定时间段内的总下载量的预估值，包括新增下载和更新下载。"
      useRatioSort
      sorts={sorts}
      onSortsChange={setSorts}
    />
  );
};

export const demoConfig = [
  {
    title: '基础用法',
    description: '传入 dataSource 和 metric 即可使用，默认开启环比排序选项',
    code: `<RatioMetricSortBy
  dataSource="sensortower"
  metric="revenue"
  sorts={sorts}
  onSortsChange={setSorts}
/>`,
    element: <BasicDemo />,
  },
  {
    title: '环比排序',
    description: '当 useRatioSort 为 true 时，下拉选项中包含"指标数值"和"指标环比(%)"两个选项',
    code: `<RatioMetricSortBy
  dataSource="sensortower"
  metric="revenue"
  useRatioSort
  sorts={sorts}
  onSortsChange={setSorts}
/>`,
    element: <RatioSortDemo />,
  },
  {
    title: '带指标提示',
    description: '通过 metricTips 为指标添加说明气泡，hover 标题时展示提示信息',
    code: `<RatioMetricSortBy
  dataSource="appannie"
  metric="downloads"
  metricTips="该指标表示应用在指定时间段内的总下载量的预估值，包括新增下载和更新下载。"
  useRatioSort
  sorts={sorts}
  onSortsChange={setSorts}
/>`,
    element: <WithTipsDemo />,
  },
];

export default demoConfig;
